const BASE_SIZE = 16 // always set to your html's base font size.

type mode = 'rem' | 'em'

export const px2rem = (px: number, mode: mode = 'rem'): string => {
  return `${px / BASE_SIZE}${mode}`
}

export const SIZE = {
  TINY: px2rem(4),
  XSMALL: px2rem(8),
  SMALL: px2rem(16),
  AVERAGE: px2rem(24),
  LARGE: px2rem(32),
  XLARGE: px2rem(48),
  HUGE: px2rem(64),
  GIGANTIC: px2rem(72),
  HALF_CONTENT_WIDTH: px2rem(640),
  MAX_CONTENT_WIDTH: px2rem(1280),
  SEARCH_WIDGET_WIDTH: px2rem(256),
}
